import { NumberField } from 'Shared/forms/Inputs';
import { LabelOnRightWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';

export function Brightness()
{
	return (
		<StyleFieldsRow>
			<BrightnessFields />
		</StyleFieldsRow>
	);
}


/* The brightness on its own, for a caller that names the location itself - see ruleProperties(). */
export function BrightnessFields()
{
	return (
		<LabelOnRightWrap label='%' narrow={true}>
			<NumberField field='brightness' />
		</LabelOnRightWrap>
	);
}
